const AmazonCognitoIdentity = require("amazon-cognito-identity-js");
import { CognitoAuth, StorageHelper } from "amazon-cognito-auth-js";
import axios from "axios";
import IndexRouter from "../router/index";
const AWS = require("aws-sdk");
import store from "@/store";
import {
    userPoolIdTeacher,
    clientIdAdmin,
    clientIdTeacher,
    userPoolIdAdmin,
    appDomain,
    redirect,
    redirectSigout,
    REGION,
    IDENTITY_POOL_ID,
} from "@/utils/config";
import Vue from "vue";
import { BaseURL } from "@/utils/config";
const poolData = {
    UserPoolId: userPoolIdTeacher,
    ClientId: clientIdTeacher,
};
const PROVIDER_KEY =
    "cognito-idp." + REGION + ".amazonaws.com/" + userPoolIdAdmin;

import jwtDecode from "jwt-decode";

const CLIENT_ID = clientIdAdmin;
const APP_DOMAIN = appDomain;
const REDIRECT_URI = redirect;
const USERPOOL_ID = userPoolIdAdmin;
const REDIRECT_URI_SIGNOUT = redirectSigout;

var authData = {
    ClientId: CLIENT_ID, // Your client id here
    AppWebDomain: APP_DOMAIN,
    TokenScopesArray: ["openid", "email", "profile"],
    RedirectUriSignIn: REDIRECT_URI,
    RedirectUriSignOut: REDIRECT_URI_SIGNOUT,
    UserPoolId: USERPOOL_ID,
};

var auth = new CognitoAuth(authData);
auth.useCodeGrantFlow();

function getUserInfoStorageKey() {
    var keyPrefix = "CognitoIdentityServiceProvider." + auth.getClientId();
    var tokenUserName = auth.signInUserSession.getAccessToken().getUsername();
    var userInfoKey = keyPrefix + "." + tokenUserName + ".userInfo";
    return userInfoKey;
}

var storageHelper = new StorageHelper();
var storage = storageHelper.getStorage();
const validateEmail = ["vnext.com.vn", "sun21.co.jp"];

function handleValidateEmail(keyHd) {
    let res = validateEmail.find((e) => e === keyHd);
    return Boolean(res);
}

/**
 * IdentityPoolトークンが付与されているAWSインスタンスを取得
 * @param {String} jwtToken
 */
const refreshCredentials = (jwtToken = undefined) =>
    new Promise((resolve, reject) => {
        AWS.config.region = REGION;

        const params = {
            IdentityPoolId: IDENTITY_POOL_ID,
        };
        if (jwtToken) {
            params.Logins = {
                [PROVIDER_KEY]: jwtToken,
            };
        }

        AWS.config.credentials = new AWS.CognitoIdentityCredentials(params);

        // 資格情報を取得
        AWS.config.credentials.get(function(err) {
            if (err) {
                console.error(err);
                reject(err);
            }
            resolve({
                accessKeyId: AWS.config.credentials.accessKeyId,
                secretAccessKey: AWS.config.credentials.secretAccessKey,
                sessionToken: AWS.config.credentials.sessionToken,
            });
        });
    });

auth.userhandler = {
    onSuccess: async function() {
        this.loggedIn = true;
        var jwtToken = auth.getSignInUserSession().getIdToken().jwtToken;
        refreshCredentials(jwtToken);
        var jwtAccessToken = auth.getSignInUserSession().getAccessToken().jwtToken;
        let jwtTokenDecode = jwtDecode(jwtToken);
        let jwtAccessTokenDecode = jwtDecode(jwtAccessToken);
        console.log("jwtTokenDecode: ", jwtTokenDecode);
        console.log("jwtToken: ", jwtAccessTokenDecode);
        const USERINFO_URL =
            "https://" + auth.getAppWebDomain() + "/oauth2/userInfo";
        var requestData = {
            headers: {
                Authorization: "Bearer " + jwtAccessToken,
            },
        };
        var requestDataCreateLog = {
            headers: {
                Authorization: "Bearer " + jwtToken,
            },
        };

        return axios.get(USERINFO_URL, requestData).then(async(response) => {
            const { data } = response;
            let alertGroupError = () =>
                Vue.ls.set("error_group", "アクセス制限されています。");
            if (!handleValidateEmail(
                    data.email.substring(data.email.lastIndexOf("@") + 1)
                ) ||
                !checkGroups(jwtTokenDecode["cognito:groups"])
            )
                return [logout(), alertGroupError()];
            let urlCreateLog = `${BaseURL}/user/create_log`;
            await axios.get(urlCreateLog, requestDataCreateLog);
            store.Auth.Authorization = jwtToken;
            store.Auth.userDetail = data;
            Vue.ls.set("Authorization", jwtToken);
            Vue.ls.set("userDetail", data);
            let refreshTo = Vue.ls.get("refreshTo");
            if (refreshTo) {
                IndexRouter.push(refreshTo).catch(() => console.error());
            } else {
                IndexRouter.push("/list-user").catch(() => console.error());
            }
        });
    },
    onFailure: function(err) {
        console.error("err: ", err);
        this.loggedIn = false;
        this.cognitoInfo = {};
        logout();
    },
};

function checkGroups(groups) {
    return Boolean(groups.find((group) => group == "Admin"));
}

function logout() {
    if (auth.isUserSignedIn()) {
        var userInfoKey = getUserInfoStorageKey();
        auth.signOut();
        Vue.ls.clear();
        store.Auth = {};
        storage.removeItem(userInfoKey);
    } else {
        auth.signOut();
        Vue.ls.clear();
    }
}
const mixin = {
    store: ["loggedIn", "cognitoInfo", "Auth"],
    data() {
        return {
            auth,
        };
    },
    methods: {
        async handleSignUpUser(username, password, email, group) {
            // 生徒・教師ユーザプール取得
            var userPool = new AmazonCognitoIdentity.CognitoUserPool(poolData);
            // 現在のログインユーザのトークンを取得
            var jwtToken = auth.getSignInUserSession().getIdToken().jwtToken;
            // 現在のログインユーザのトークンを取得
            await refreshCredentials(jwtToken);
            var attributeList = [];
            var dataEmail = {
                Name: "email",
                Value: email,
            };
            var attributeEmail = new AmazonCognitoIdentity.CognitoUserAttribute(
                dataEmail
            );
            attributeList.push(attributeEmail);
            return new Promise((resolve, reject) => {
                // 生徒・教師ユーザプールにユーザを登録
                userPool.signUp(username, password, attributeList, null, function(
                    err,
                    dataSignUp
                ) {
                    if (err) {
                        console.log(err);
                        reject(err);
                    }
                    console.log("dataSignUp: ", dataSignUp.userSub);
                    var cognitoidentityserviceprovider = new AWS.CognitoIdentityServiceProvider();
                    var confirmAddUserToGroup = {
                        GroupName: group,
                        UserPoolId: userPoolIdTeacher /* required */ ,
                        Username: username /* required */ ,
                    };
                    // ユーザをTeacherグループに追加する
                    cognitoidentityserviceprovider.adminAddUserToGroup(
                        confirmAddUserToGroup,
                        function(err) {
                            if (err) {
                                reject(err);
                            } else {
                                resolve(dataSignUp.userSub);
                            }
                        }
                    );
                });
            });
        },
        handleDisableUser(username) {
            return new Promise(function(resolve, reject) {
                var cognitoidentityserviceprovider = new AWS.CognitoIdentityServiceProvider();
                var paramsDisableUser = {
                    UserPoolId: userPoolIdTeacher /* required */ ,
                    Username: username.toString() /* required */ ,
                };
                cognitoidentityserviceprovider.adminDisableUser(
                    paramsDisableUser,
                    function(err, data) {
                        if (err) {
                            reject(err);
                        } else {
                            resolve(data);
                        }
                    }
                );
            });
        },
        handleLogin() {
            auth.getSession();
        },
        handleLogout: logout,
        getUserInfoStorageKey,
    },
};

export default mixin;